export const GovernmentIdAttributeNameExtraction: Record<string, string> = {
  'address-street-1': 'Address Street 1',
  'address-street-2': 'Address Street 2',
  'address-city': 'Address City',
  'address-subdivision': 'Address Subdivision',
  'address-postal-code': 'Address Postal Code',
  'name-first': 'Name First',
  'name-middle': 'Name Middle',
  'name-last': 'Name Last',
  birthdate: 'Birthdate',
  'issue-date': 'Issue Date',
  'expiration-date': 'Expiration Date',
  'social-security-number': 'Social Security Number',
  'phone-number': 'Phone Number',
  'identification-number': 'Identification Number',
};
